import { useEffect, useState } from 'react'
import { Col, Form, OverlayTrigger, Row, Table, Tooltip } from 'react-bootstrap'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import ReactPaginate from 'react-paginate'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { CustomButton } from '../../components/CustomButton'
import { CustomSpinner } from '../../components/CustomSpinner'
import Navbar from '../../components/navbar/navbar'
import { useOrderTable } from '../../hooks/useOrderTable'
import { usePaginate } from '../../hooks/usePaginate'
import PedidosCompraService from '../../services/database/PedidosCompraService'
import { formatDate } from '../../utils/formatDate'
import { formatPrice } from '../../utils/formatPrice'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'
import { Buttons, Center, Container, Section } from './styles'

import {
  BoxFill,
  CaretDown,
  CaretUp,
  CashCoin,
  PencilFill,
  PlusCircleFill,
  Search,
  TrashFill,
  XCircleFill,
} from 'react-bootstrap-icons'
import WmsConfBonusService from '../../services/database/WmsConfBonusService'

export function PedidosCompra() {
  const [ordersBuy, setOrdersBuy] = useState([])
  const [termType, setTermType] = useState('')
  const [termSearch, setTermSearch] = useState('')
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [isOrdersLoading, setIsOrdersLoading] = useState(true)
  const [isSearchLoading, setIsSearchLoading] = useState(false)
  const [isDeleteOrderLoading, setIsDeleteOrderLoading] = useState(false)
  const [isSentWMSLoading, setIsSentWMSLoading] = useState(false)

  const navigate = useNavigate()

  async function loadOrdersBuy() {
    try {
      setIsOrdersLoading(true)

      const ordersBuyData = await PedidosCompraService.getAll()

      setOrdersBuy(ordersBuyData)
    } catch (err) {
      toast.error('Erro ao buscar os pedidos de compra!')
    } finally {
      setIsOrdersLoading(false)
    }
  }

  function handleClearFilters() {
    setTermType('')
    setTermSearch('')
    setStartDate('')
    setEndDate('')

    loadOrdersBuy()
  }

  async function handleSendWMS(idPedidoCompra, index) {
    try {
      setIsSentWMSLoading((prevState) => ({
        ...prevState,
        [index]: true,
      }))

      const num_bonus = await WmsConfBonusService.create(idPedidoCompra)

      toast.success(`Bônus criado com ID ${num_bonus}`)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível criar o bônus WMS!')
    } finally {
      setIsSentWMSLoading((prevState) => ({
        ...prevState,
        [index]: false,
      }))
    }
  }

  async function handleDeletePedidoCompra(orderId) {
    try {
      setIsDeleteOrderLoading(true)

      await PedidosCompraService.delete(orderId)

      toast.success('Pedido de Compra deletado com sucesso!')

      loadOrdersBuy()
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao deletar o pedido de compra')
    } finally {
      setIsDeleteOrderLoading(false)
    }
  }

  async function handleSearch() {
    try {
      setIsSearchLoading(true)

      console.log({ termType, termSearch, startDate, endDate })

      const ordersBuySearched = await PedidosCompraService.getBySearch({
        termType,
        termSearch,
        startDate,
        endDate,
      })

      setOrdersBuy(ordersBuySearched)
    } catch (err) {
      console.log(`Erro ao fazer a buscar: ${err}`)
      toast.error('Não foi possível concluir a busca!')
    } finally {
      setIsSearchLoading(false)
    }
  }

  const {
    sortedArray: sortedOrdersBuy,
    check,
    handleOrganize,
    orderType,
  } = useOrderTable(ordersBuy, 'datahora', 'desc')

  const { filteredItems, handlePageClick, pageCount, setItemsPerPage } =
    usePaginate(sortedOrdersBuy, orderType)

  function getPlaceholder() {
    switch (termType) {
      case 'pedido': {
        return 'Número...'
      }
      case 'cliente': {
        return 'Fornecedor...'
      }
      case 'idpedidoloja': {
        return 'ID Pedido Loja...'
      }
      default: {
        return 'Pesquise...'
      }
    }
  }

  useEffect(() => {
    loadOrdersBuy()
  }, [])

  return (
    <>
      <Navbar />

      <Container className="mt-page">
        <h1>Pedidos de Compra</h1>

        {isOrdersLoading ? (
          <Center>
            <CustomSpinner />
          </Center>
        ) : (
          <>
            <Row className="mb-3">
              <Col>
                <Form.Label>Pedidos p/ pág:</Form.Label>
                <Form.Select
                  onChange={(e) => {
                    setItemsPerPage(Number(e.target.value))
                  }}
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </Form.Select>
              </Col>

              <Col>
                <Form.Label>Tipo de Pesquisa</Form.Label>
                <Form.Select
                  value={termType}
                  onChange={(e) => setTermType(e.target.value)}
                >
                  <option value="">Selecione...</option>
                  <option value="pedido">Número</option>
                  <option value="cliente">Fornecedor</option>
                  <option value="idpedidoloja"> ID Pedido Loja</option>
                </Form.Select>
              </Col>

              <Col
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                }}
              >
                <Form.Control
                  disabled={termType === ''}
                  value={termSearch}
                  onChange={(e) => setTermSearch(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleSearch()
                    }
                  }}
                  placeholder={getPlaceholder()}
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <Form.Label>Data Inicial:</Form.Label>
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  selectsStart
                  dateFormat="dd/MM/yyyy"
                  startDate={startDate}
                  customInput={<Form.Control />}
                />
              </Col>

              <Col>
                <Form.Label>Data Final:</Form.Label>

                <DatePicker
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  selectsEnd
                  dateFormat="dd/MM/yyyy"
                  startDate={startDate}
                  endDate={endDate}
                  customInput={<Form.Control />}
                />
              </Col>

              <Col
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-end',
                }}
              >
                <Buttons>
                  <CustomButton
                    color="#e10c0c"
                    title="Limpar Filtros"
                    onClick={handleClearFilters}
                  >
                    <XCircleFill />
                  </CustomButton>

                  <CustomButton
                    color="#0645b8"
                    title="Pesquisar"
                    isLoading={isSearchLoading}
                    isLoadingText={'Pesquisando...'}
                    onClick={handleSearch}
                    isDisabled={
                      (!termType && !startDate) ||
                      (termType && !termSearch) ||
                      (startDate && !endDate) ||
                      (!startDate && endDate)
                    }
                  >
                    <Search />
                  </CustomButton>
                </Buttons>
              </Col>
            </Row>

            <Section>
              <CustomButton
                title="Incluir Pedido"
                color="#14a24e"
                styles={{
                  width: 200,
                }}
                onClick={() => navigate('/novo/pedido-compra')}
              >
                <PlusCircleFill />
              </CustomButton>
            </Section>

            {filteredItems.length > 0 && (
              <>
                <Table
                  hover
                  responsive
                >
                  <thead>
                    <tr>
                      <th onClick={() => handleOrganize('pedido')}>
                        <span>Número</span>
                        <CaretUp color={check('pedido', 'asc')} />
                        <CaretDown color={check('pedido', 'desc')} />
                      </th>
                      <th></th>
                      <th onClick={() => handleOrganize('idpedidoloja')}>
                        <span>ID Pedido Loja</span>
                        <CaretUp color={check('idpedidoloja', 'asc')} />
                        <CaretDown color={check('idpedidoloja', 'desc')} />
                      </th>
                      <th onClick={() => handleOrganize('data')}>
                        <span>Data do Pedido</span>
                        <CaretUp color={check('data', 'asc')} />
                        <CaretDown color={check('data', 'desc')} />
                      </th>
                      <th onClick={() => handleOrganize('cliente')}>
                        <span>Fornecedor/Cliente</span>
                        <CaretUp color={check('cliente', 'asc')} />
                        <CaretDown color={check('cliente', 'desc')} />
                      </th>
                      <th onClick={() => handleOrganize('valor')}>
                        <span>Valor</span>
                        <CaretUp color={check('valor', 'asc')} />
                        <CaretDown color={check('valor', 'desc')} />
                      </th>
                      <th>
                        <span>Status</span>
                      </th>
                      <th>
                        <span> Obs. Internas</span>
                      </th>
                      <th onClick={() => handleOrganize('datahora')}>
                        <span>Data de Criação</span>
                        <CaretUp color={check('datahora', 'asc')} />
                        <CaretDown color={check('datahora', 'desc')} />
                      </th>
                      <th>Ações</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredItems.map((orderBuy, index) => (
                      <tr key={orderBuy.pedido}>
                        <td>{orderBuy.pedido}</td>
                        <td>
                          <td>
                            <OverlayTrigger
                              overlay={
                                <Tooltip>
                                  {orderBuy.lancado === true
                                    ? 'Conta à Pagar Lançada'
                                    : 'Conta à Pagar Não Lançada'}
                                </Tooltip>
                              }
                            >
                              <CashCoin
                                size={25}
                                color={
                                  orderBuy.lancado === true
                                    ? '#2ecc71'
                                    : '#e74c3c'
                                }
                              />
                            </OverlayTrigger>
                          </td>
                        </td>
                        <td>{orderBuy.idpedidoloja}</td>
                        <td>{formatDate(orderBuy.data)}</td>
                        <td>{orderBuy.cliente}</td>
                        <td>{formatPrice(orderBuy.valor)}</td>
                        <td>{orderBuy.status}</td>
                        <td>{orderBuy.detalhes_pedido}</td>
                        <td>
                          {formatDate(orderBuy.datahora, 'dd/MM/yyyy HH:m:s')}
                        </td>
                        <td>
                          <div
                            style={{
                              display: 'flex',
                            }}
                          >
                            <OverlayTrigger overlay={<Tooltip>Editar</Tooltip>}>
                              <CustomButton
                                color="#d76714"
                                onClick={() =>
                                  navigate(`/pedidos-compra/${orderBuy.pedido}`)
                                }
                              >
                                <PencilFill size={16} />
                              </CustomButton>
                            </OverlayTrigger>

                            <OverlayTrigger
                              overlay={
                                <Tooltip>Criar Bônus de Entrada</Tooltip>
                              }
                            >
                              <CustomButton
                                color="#2049ff"
                                onClick={() =>
                                  handleSendWMS(orderBuy.pedido, index)
                                }
                                isLoading={isSentWMSLoading[index]}
                              >
                                <BoxFill size={16} />
                              </CustomButton>
                            </OverlayTrigger>

                            <OverlayTrigger
                              overlay={<Tooltip>Excluir</Tooltip>}
                            >
                              <CustomButton
                                color="#b70000"
                                onClick={() =>
                                  handleDeletePedidoCompra(orderBuy.pedido)
                                }
                                isLoading={isDeleteOrderLoading}
                              >
                                <TrashFill size={16} />
                              </CustomButton>
                            </OverlayTrigger>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                <ReactPaginate
                  breakLabel="..."
                  nextLabel="Próxima"
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={5}
                  pageCount={pageCount}
                  previousLabel="Anterior"
                  renderOnZeroPageCount={null}
                  containerClassName="pagination"
                  activeClassName="active"
                />
              </>
            )}
          </>
        )}
      </Container>
    </>
  )
}
